import { render, staticRenderFns } from "./tableGovernancePolicy.vue?vue&type=template&id=9ce24b86&scoped=true"
import script from "./tableGovernancePolicy.vue?vue&type=script&lang=js"
export * from "./tableGovernancePolicy.vue?vue&type=script&lang=js"
import style0 from "./tableGovernancePolicy.vue?vue&type=style&index=0&id=9ce24b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce24b86",
  null
  
)

export default component.exports